// Duck-typed: detects a Graph 429 throttling error surfaced by the SDK after its retries are exhausted.
export const isThrottleError = (error: unknown): boolean => {
    if (typeof error !== "object" || error === null) return false;

    const candidate = error as {
        isThrottle?: unknown;
        name?: unknown;
        status?: unknown;
    };

    return (
        candidate.isThrottle === true ||
        candidate.name === "GraphThrottleError" ||
        candidate.status === 429
    );
};
